import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationsComponent } from './notifications/notifications.component';
import { MaterialModule } from '../shared/material/material.module';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NotificationsRoutingModule
  ]
})
export class NotificationsModule { }

export { NotificationsComponent } from './notifications/notifications.component';
